import { Navigate, useLocation } from "react-router-dom";

const AuthWrapper = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("skillanthem_auth");
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default AuthWrapper;